import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import * as microsoftTeams from '@microsoft/teams-js';
import { getRootUrl } from 'helpers/url';
import { isUserTeacher } from 'helpers/user';
import { getHaldorAssignments, getMicrosoftEducationAssignments, setAssignmentServices, getAssignmentStatus } from 'actions/assignments';
import { getEducationGroups, getSections, getSection } from 'actions/sections';
import Modal from 'containers/Modals/Modal';
import AssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';
import SectionForm from 'containers/Forms/SectionForm';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Expandable from 'UI/Elements/Expandable';
import { CardsContainer } from 'components/Cards/Card';
import LoadingCards from 'components/Cards/LoadingCard';
import Task from 'components/Presentation/Cards/AssignmentCard';
import SectionTitle from 'components/Presentation/SectionTitle';
import { Icon, TooltipMenu, Button } from '@haldor/ui';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

var MyAssignments = /*#__PURE__*/function (_Component) {
  _inherits(MyAssignments, _Component);

  var _super = _createSuper(MyAssignments);

  function MyAssignments(props) {
    var _this;

    _classCallCheck(this, MyAssignments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "consentedToTenantService", function (serviceId) {
      return _this.props.tenantServices != null && _this.props.tenantServices.find(function (service) {
        return service.serviceId == serviceId && moment(service.serviceEnd).isSameOrAfter(moment(), 'day') && service.consented !== null;
      }) != null;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (!_this.consentedToTenantService("HALDOR_COURSEPLANNING")) return;

      _this.props.setAssignmentServices(_this.services);

      if (_this.props.sections.length > 0) {
        _this.getData(_this.props.sections);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.sections.length == 0 && nextProps.sections != null && nextProps.sections.length > 0) {
        _this.getData(nextProps.sections);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getData", function (sections) {
      microsoftTeams.app.getContext().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
          var section, promises;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  section = sections.find(function (section) {
                    return section.graphId == context.team.groupId;
                  });

                  if (!(section != null)) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 4;
                  return _this.props.getSection(section.id);

                case 4:
                  _this.setState({
                    sectionId: section.id,
                    graphId: section.graphId,
                    noSectionFound: false
                  });

                  promises = [];

                  if (_this.services.microsoft) {
                    promises.push(_this.props.getMicrosoftEducationAssignments(context.team.groupId));
                  }

                  if (_this.services.haldor) {
                    promises.push(_this.props.getHaldorAssignments(context.team.groupId));
                  }

                  Promise.all(promises).then(function () {
                    _this.setState({
                      loading: false
                    });
                  });
                  _context.next = 12;
                  break;

                case 11:
                  _this.setState({
                    noSectionFound: true,
                    teamsContext: context
                  });

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "DisplayNoAssignments", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('no-assignments-results')));
    });

    _defineProperty(_assertThisInitialized(_this), "displayNoConsent", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'left'
        }
      }, /*#__PURE__*/React.createElement("div", null, _this.props.translate('To use Microsoft Teams assignments in Planning for Educators, you need to request permission from your IT administrator.')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: '1rem'
        },
        onClick: function onClick(e) {
          e.preventDefault();

          _this.navigateToOnboarding();
        }
      }, _this.props.translate('Request permission')));
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalIsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "enableOverlayWarningClose", function (enable) {
      _this.setState({
        enableOverlayWarning: enable
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptAgree", function () {
      _this.setState({
        modalIsOpen: false,
        overlayWarningPrompt: false,
        enableOverlayWarning: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptClose", function () {
      _this.setState({
        overlayWarningPrompt: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "navigateToOnboarding", function () {
      _this.props.history.push('/haldor-tab/onboarding');
    });

    _defineProperty(_assertThisInitialized(_this), "CreateButton", function () {
      if (!_this.services.haldor) {
        return null;
      }

      if (_this.props.disableCreate) {
        return null;
      } // Do not show button until loading is complete


      if (_this.state.loading) {
        return null;
      }

      if (_this.props.group == null) {
        return null;
      }

      var isTeacher = isUserTeacher(_this.props.currentUser);

      if (isTeacher) {
        if (_this.state.noSectionFound) {
          return null;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "create-container",
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: /*#__PURE__*/React.createElement(Button, {
            type: "secondary"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Plus"
          }), " ", _this.props.translate('Create'))
        }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleSingleAssignmentForm
        }, _this.props.translate('create-group-assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
          onClick: _this.toggleMultipleAssignmentForm
        }, _this.props.translate('task-create-button'))));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSingleAssignmentForm", function () {
      _this.setState({
        singleAssignmentFormModal: !_this.state.singleAssignmentFormModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMultipleAssignmentForm", function (skipModal) {
      _this.setState({
        multipleAssignmentFormModal: !_this.state.multipleAssignmentFormModal
      }, function () {
        if (!_this.state.multipleAssignmentFormModal) {
          _this.getData(_this.props.sections);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "teamsTabCloseForm", function () {
      _this.setState({
        noSectionFound: false
      }, function () {
        window.location = window.location.href;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var isTeacher = isUserTeacher(_this.props.currentUser);

      var isFrame = _this.isIframe();

      if (_this.state.noSectionFound && isTeacher) {
        return /*#__PURE__*/React.createElement(SectionForm, {
          editView: false,
          teamsContext: _this.state.teamsContext,
          teamsTabCloseForm: _this.teamsTabCloseForm,
          tab: "assignments"
        });
      }

      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement(LoadingCards, {
          count: 3
        });
      }

      var count = 0;

      if (_this.props.assignments != null) {
        count = _this.props.assignments.length;
      }

      if (_this.props.teamsAssignments != null) {
        count += _this.props.teamsAssignments.length;
      }

      if (count == 0) {
        return _this.DisplayNoAssignments();
      }

      var sectionId = null;

      if (_this.props.groupid != null && !isFrame) {
        sectionId = _this.props.groupid;
      } else if (isFrame && _this.state.graphId != null) {
        sectionId = _this.state.sectionId;
      }

      return /*#__PURE__*/React.createElement("div", null, _this.renderDrafts(sectionId), _this.renderOverdue(sectionId), _this.renderCurrent(sectionId), _this.renderUpcoming(sectionId), _this.renderSubmitted(sectionId), _this.renderClosed(sectionId));
    });

    _this.state = {
      loading: true,
      lists: [],
      modalIsOpen: false,
      tasks: null,
      enableOverlayWarning: false,
      overlayWarningPrompt: false,
      sectionId: null,
      graphId: null,
      noSectionFound: false,
      teamsContext: null,
      multipleAssignmentFormModal: false,
      singleAssignmentFormModal: false,
      draftOpen: true,
      currentOpen: true,
      overDueOpen: false,
      upcomingOpen: false,
      submittedOpen: false,
      closedOpen: false,
      loadingGroups: true,
      consented: _this.consentedToTenantService("HALDOR_COURSEPLANNING")
    };
    _this.services = {
      microsoft: props.services.microsoft,
      haldor: props.services.haldor
    };
    return _this;
  }

  _createClass(MyAssignments, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "renderTask",
    value: function renderTask(assignment) {
      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement(Task, {
        key: assignment.id,
        assignment: assignment,
        isTeacher: isTeacher
      });
    }
  }, {
    key: "renderDrafts",
    value: function renderDrafts(sectionId) {
      var _this2 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (!isTeacher) {
        return null;
      }

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.drafts;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this2.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('draft-list-title'),
        open: this.state.draftOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this2.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderOverdue",
    value: function renderOverdue(sectionId) {
      var _this3 = this;

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.overdue;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this3.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('overdue-list-title'),
        open: this.state.overDueOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this3.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderCurrent",
    value: function renderCurrent(sectionId) {
      var _this4 = this;

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.current;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this4.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('current-list-title'),
        open: this.state.currentOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this4.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderUpcoming",
    value: function renderUpcoming(sectionId) {
      var _this5 = this;

      var limit = 99999;

      if (this.props.limit != null) {
        limit = this.props.limit;
      }

      var list = this.props.upcoming;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this5.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('upcoming-list-title'),
        open: this.state.upcomingOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment, index) {
        if (index < limit) {
          return _this5.renderTask(assignment);
        }
      })), this.showAllLink());
    }
  }, {
    key: "renderSubmitted",
    value: function renderSubmitted(sectionId) {
      var _this6 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (isTeacher || this.props.limit != null) {
        return null;
      }

      var list = this.props.submitted;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this6.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('submitted-list-title'),
        open: this.state.submittedOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment) {
        return _this6.renderTask(assignment);
      })), this.showAllLink());
    }
  }, {
    key: "renderClosed",
    value: function renderClosed(sectionId) {
      var _this7 = this;

      var isTeacher = isUserTeacher(this.props.currentUser);

      if (!isTeacher || this.props.limit != null) {
        return null;
      }

      var list = this.props.closed;

      if (sectionId != null) {
        list = list.filter(function (t) {
          if (t.id == parseInt(t.id, 10)) {
            return t.sectionId == sectionId;
          } else {
            return t.classId == _this7.state.graphId;
          }
        });
      }

      if (list.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('closed-list-title'),
        open: this.state.closedOpen
      }, /*#__PURE__*/React.createElement(CardsContainer, null, list.map(function (assignment) {
        return _this7.renderTask(assignment);
      })), this.showAllLink());
    }
  }, {
    key: "showAllLink",
    value: function showAllLink() {
      if (this.props.limit == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        style: {
          width: '100%',
          textAlign: 'center',
          display: 'block'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          color: '#ccc',
          textDecoration: 'none'
        },
        to: "".concat(getRootUrl(), "assignments")
      }, this.props.translate('show-all')));
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props = this.props,
          groupid = _this$props.groupid,
          planid = _this$props.planid;
      var assignmentFormParams = {
        enableOverlayWarningClose: this.enableOverlayWarningClose,
        overlayWarningPromptAgree: this.overlayWarningPromptAgree,
        overlayWarningPromptClose: this.overlayWarningPromptClose,
        overlayWarningPrompt: this.state.overlayWarningPrompt,
        enableOverlayWarning: this.state.enableOverlayWarning,
        onAbort: this.toggleSingleAssignmentForm,
        editView: false,
        cloneView: false,
        groupid: groupid,
        planid: planid
      };
      return /*#__PURE__*/React.createElement("div", {
        ref: "overview_tasks",
        className: "my_tasks tasks_is_teams"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.singleAssignmentFormModal,
        onClose: this.toggleSingleAssignmentForm,
        title: this.props.translate('task-create-button')
      }, /*#__PURE__*/React.createElement(AssignmentForm, _extends({}, assignmentFormParams, {
        groupid: this.props.groupid,
        planid: this.props.planid,
        editView: false
      }))), !this.state.loading ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.multipleAssignmentFormModal,
        onClose: function onClose() {
          _this8.toggleMultipleAssignmentForm(false);
        },
        title: this.props.translate('task-create-button')
      }, /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        onAbort: this.toggleMultipleAssignmentForm,
        groupId: this.props.groupid,
        section: this.props.activeSection
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Assignments"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('tasks-header-overview')), this.CreateButton(), this.props.limit ? /*#__PURE__*/React.createElement(Link, {
        to: "".concat(getRootUrl(), "assignments"),
        className: "see-more"
      }, this.props.translate('show-all')) : null)), this.state.consented ? this.renderContent() : this.displayNoConsent());
    }
  }]);

  return MyAssignments;
}(Component);

function mapStateToProps(state) {
  return {
    tenantServices: state.Services.tenantServices,
    submitted: state.assignments.submitted,
    closed: state.assignments.closed,
    drafts: state.assignments.drafts,
    overdue: state.assignments.overdue,
    upcoming: state.assignments.upcoming,
    current: state.assignments.current,
    assignments: state.assignments.assignments,
    teamsAssignments: state.assignments.teamsAssignments,
    services: state.Services.availableServices,
    sections: state.sections.educationGroups,
    group: state.sections.graphSection,
    activeSection: state.sections.activeSection,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {
  getMicrosoftEducationAssignments: getMicrosoftEducationAssignments,
  getSections: getSections,
  getEducationGroups: getEducationGroups,
  getHaldorAssignments: getHaldorAssignments,
  setAssignmentServices: setAssignmentServices,
  getSection: getSection,
  getAssignmentStatus: getAssignmentStatus
})(MyAssignments));